import moment from 'moment';
import { TYPE_COMMANDE } from '@/configuration/devisConf';

export default function genererCritereRecherche() {
  return {
    auto: '',
    code: '',
    libelle: '',
    fournisseurId: null,
  };
}

export function genererCritereRechercheProduits() {
  return {
    auto: '',
    categorie: [],
    actif: true,
    avecLiaisons: null,
  };
}

export function genererCritereRechercheListeVente() {
  const dateDeBase = moment(new Date(moment().year(), 8, 1));
  let dateDebut = null;
  let dateFin = null;
  if (moment().isBefore(dateDeBase)) {
    dateDebut = new Date(moment().year() - 1, 8, 1);
    dateFin = new Date(moment().year(), 7, 31);
  } else {
    dateDebut = new Date(moment().year(), 8, 1);
    dateFin = new Date(moment().year() + 1, 7, 31);
  }
  return {
    auto: '',
    datesEcheance: {
      dateDebut,
      dateFin,
    },
    planMediaIds: [],
    code: '',
    produitsIds: [],
    payeurs: [],
    annonceurs: [],
    typesDevisCommandeFacture: [TYPE_COMMANDE],
    afficherDevis: true,
  };
}
